import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MyShowLogoNeon } from '@/components/Logo';
import { toast } from 'sonner';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { useAuthStore } from '@/stores/authStore';

export function LoginPage() {
  const navigate = useNavigate();
  const signIn = useAuthStore(s => s.signIn);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    const { error } = await signIn(email, password);
    setLoading(false);
    if (error) {
      toast.error(error);
      return;
    }
    navigate(useAuthStore.getState().isPartner ? '/parceiro' : '/dashboard');
  }

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex bg-black text-white p-12 flex-col justify-between relative overflow-hidden">
        {/* Glow roxo no fundo */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-600/20 rounded-full blur-3xl" />
        <Link to="/" className="relative flex items-center">
          <MyShowLogoNeon height={120} />
        </Link>
        <div>
          <p className="text-3xl font-bold leading-tight">
            "Minha loja virou ponto de mídia. Clientes param pra ver as ofertas antes mesmo de entrar."
          </p>
          <p className="mt-4 text-white/80 text-sm">— Proprietário de loja de roupas, SP</p>
        </div>
        <div className="text-xs text-white/60">© Visual Software</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <h1 className="text-3xl font-bold">Entrar</h1>
          <p className="mt-2 text-muted-foreground">Bem-vindo de volta</p>

          <form onSubmit={onSubmit} className="mt-8 space-y-4">
            <div className="space-y-2">
              <label htmlFor="email" className="text-sm font-medium">Email</label>
              <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" />
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="text-sm font-medium">Senha</label>
                <Link to="/forgot-password" className="text-xs text-brand-600 hover:underline">Esqueci a senha</Link>
              </div>
              <Input id="password" type="password" required value={password} onChange={e => setPassword(e.target.value)} />
            </div>
            <Button type="submit" className="w-full" loading={loading}>Entrar</Button>
          </form>

          <p className="mt-8 text-sm text-center text-muted-foreground">
            Não tem conta? <Link to="/cadastro" className="text-brand-600 font-medium hover:underline">Comece grátis</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
